<template>
  <div>
    {{ descriptionSections[0] }}
    <span
        v-for="(orderLine, index) in this.merchantOrderLines"
        :key="orderLine.sku"
    ><note-url
        :merchantOrderLine= orderLine
    />
      <span v-if="index != merchantOrderLines.length - 1">
        ,
      </span>
    </span>
    {{ descriptionSections[descriptionSections.length-1] }}
  </div>
</template>
<script>
import NoteUrl from './NoteUrl';

export default {
  name: 'notes-with-url',
  components: {
    NoteUrl,
  },
  props: {
    merchantOrderLines: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    descriptionSections () {
      return this.description.split(/#([\w]+)/);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

</style>
